//
//
//
//
//
//
//
//
//
//
//
//

import {
  VApp,
  VMain,
} from "vuetify/lib";

import NavigationButton from "./components/positioned/NavigationButton.vue";
import Banner from "./components/positioned/Banner.vue";

export default {
  name: "App",
  components: {
    VApp,
    VMain,
    NavigationButton,
    Banner,
  },
  data: function () {
    return {};
  },
};
